import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GoogleAdComponent } from './google-ad.component';
import { AdsenseModule } from 'ng2-adsense';
import { environment as env } from 'src/environments/environment';

@NgModule({
	declarations: [GoogleAdComponent],
	imports: [
		CommonModule,
		AdsenseModule.forRoot({
			adClient: env.GOOGLE_ADSENSE.adClient,
			display: env.GOOGLE_ADSENSE.display,
			fullWidthResponsive: true,
		}),
	],
	exports: [GoogleAdComponent],
})
export class GoogleAdModule {}
